<template>
  <v-container
    id="templateSummaryDetails"
  >
    <div class="oe-summary-title">
      <v-btn
        class="mx-2"
        fab
        dark
        x-small
        :color="approvals.color"
        @click="toggleTemplateDisplay(template)"
      >
        <v-icon
          v-show="!template.displaySection"
          dark
        >
          mdi-arrow-expand-vertical
        </v-icon>
        <v-icon
          v-show="template.displaySection"
          dark
        >
          mdi-arrow-expand-horizontal
        </v-icon>
      </v-btn>
      {{ template.title }}
    </div>
    <div
      v-for="(section,sectionKey) in template.sections"
      :key="sectionKey"
    >
      <v-fab-transition>
        <template-section-summary
          v-show="template.displaySection"
          :section="section"
        />
      </v-fab-transition>
    </div>
    <v-fab-transition>
      <approval
        v-show="template.displaySection"
        :approvals="approvals"
        :allow-change="!print"
        title="Template"
        @approval:changed="$emit('approval:changed')"
      />
    </v-fab-transition>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'TemplateSummaryDetails',

    components: {
      Approval: () => import('./Approval'),
      TemplateSectionSummary: () => import('./TemplateSectionSummary'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      template: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      answersResource: new TroodyApi('oeTemplateAnswer/'),
      approvals: null,
    }),

    watch: {
      expanded (val) {
        if (this.template) {
          this.template.displaySection = val
        }
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.approvals = new Approvals(this.openEnrollment.id, this.template.productTemplateId, true, this.template.oeEligibilityGroupId)
        if (this.template) {
          this.template.displaySection = this.expanded
        }
      },

      toggleTemplateDisplay (template) {
        if (template) {
          template.displaySection = !template.displaySection
          this.$forceUpdate()
        }
      },
    },
  }
</script>
